import styles from '../globals/legal.module.scss'

function PrivacyPolicy() {
    return (
        <div className={styles.legalPage}>
            <h1>Privacy Policy</h1>
            <p className={styles.subtitle}>Evans Hughes Ltd trading as Motor Finance Claims Advice</p>
            <p className={styles.lastUpdated}>Last Updated: 15th June 2026</p>

            <h2>1. Who We Are</h2>
            <p>Motor Finance Claims Advice is a trading style of Evans Hughes Ltd.</p>
            <p>
                Evans Hughes Ltd is a company registered in England and Wales under company number 12573301, with its
                registered office at 128 City Road, London, EC1V 2NX.
            </p>
            <p>
                Evans Hughes Ltd is authorised and regulated by the Financial Conduct Authority as a Claims Management
                Company.
            </p>
            <p>FCA Firm Reference Number: 927014</p>
            <p>ICO Registration Number: ZA754708</p>
            <p>
                For the purposes of UK data protection legislation, Evans Hughes Ltd acts as an independent Data
                Controller in respect of the personal data it receives, stores, uses or otherwise processes for
                marketing, enquiry handling, referral and compliance purposes.
            </p>
            <p>
                Where your personal data is passed to Sentinel Legal Ltd, Sentinel Legal Ltd will usually act as an
                independent Data Controller in respect of the personal data it receives and processes for legal
                services, claim assessment, client onboarding, claim management, regulatory compliance and related
                purposes.
            </p>

            <h2>2. Contact Details</h2>
            <p>You can contact Evans Hughes Ltd using the details below:</p>
            <p>
                Evans Hughes Ltd
                <br />
                128 City Road
                <br />
                London
                <br />
                EC1V 2NX
                <br />
                Email: info@evanshughes.co.uk
                <br />
                Phone: 0330 053 2626
            </p>
            <p>
                If your query relates to claim processing or legal services provided by Sentinel Legal Ltd, you should
                contact Sentinel Legal Ltd directly.
            </p>

            <h2>3. How Your Data Flows</h2>
            <p>
                Your personal data may be processed by different organisations depending on how you interact with us,
                how your enquiry is submitted, and whether you choose to proceed with a motor finance claim.
            </p>

            <h3>3.1 Data Collected by Offer Vault</h3>
            <p>
                If you submitted your details via OfferVault.co.uk or an Offer Vault campaign, your personal data was
                collected by:
            </p>
            <p>
                Be Claims Ready Ltd trading as Offer Vault
                <br />
                Company Number: 11183295
                <br />
                Registered Office: 8 Cwrt Ty Mawr, Penarth, Vale Of Glamorgan, CF64 3PZ
                <br />
                ICO Registration: ZB939102
                <br />
                Email: info@beclaimsready.co.uk
            </p>
            <p>Offer Vault acts as an independent Data Controller for:</p>
            <ul>
                <li>collecting your personal data;</li>
                <li>presenting consent wording and privacy information at the point your data is collected;</li>
                <li>obtaining and storing your marketing consent;</li>
                <li>
                    recording consent logs, including IP address, time/date, source page, form version and marketing
                    permissions;
                </li>
                <li>
                    securely transferring your enquiry information to Evans Hughes Ltd where valid consent has been
                    obtained and evidenced, or where the transfer is necessary to respond to a clear request made by
                    you.
                </li>
            </ul>
            <p>
                If your query relates to how your data was originally collected, the wording you saw when submitting
                your details, or the consent obtained by Offer Vault, you should contact Offer Vault directly at:
                info@beclaimsready.co.uk
            </p>

            <h3>3.2 Data Received Indirectly by Evans Hughes Ltd</h3>
            <p>
                Evans Hughes Ltd may receive your personal data indirectly from Offer Vault or another approved
                marketing partner where you have submitted an enquiry about a motor finance claim.
            </p>
            <p>Where we receive your personal data indirectly, the categories of data we may receive include:</p>
            <ul>
                <li>your name;</li>
                <li>telephone number;</li>
                <li>email address;</li>
                <li>postcode or address information, where provided;</li>
                <li>basic enquiry details;</li>
                <li>campaign source;</li>
                <li>marketing consent status;</li>
                <li>date and time of enquiry;</li>
                <li>IP address or consent log information;</li>
                <li>records showing the wording or form version you saw when submitting your enquiry.</li>
            </ul>
            <p>Evans Hughes Ltd uses this information to:</p>
            <ul>
                <li>contact you about your motor finance claim enquiry;</li>
                <li>confirm whether you wish to receive further information;</li>
                <li>assess whether your enquiry may be suitable for referral to Sentinel Legal Ltd;</li>
                <li>keep records of consent and communications;</li>
                <li>comply with FCA, data protection and other regulatory obligations;</li>
                <li>monitor the quality and compliance of marketing activity;</li>
                <li>deal with complaints or data queries.</li>
            </ul>
            <p>
                Evans Hughes Ltd will normally provide you with this privacy information at the first point of contact,
                or as soon as reasonably practicable after receiving your personal data, where required by UK GDPR.
            </p>

            <h3>3.3 Marketing Contact by Evans Hughes Ltd</h3>
            <p>
                If you provided consent directly to Evans Hughes Ltd, via Offer Vault, or via another approved marketing
                partner, Evans Hughes Ltd may contact you regarding your motor finance claim enquiry.
            </p>
            <p>Evans Hughes Ltd acts as an independent Data Controller in respect of:</p>
            <ul>
                <li>marketing communications we send;</li>
                <li>initial enquiry discussions;</li>
                <li>records of telephone calls, SMS messages, emails and other communications;</li>
                <li>consent and opt-out records;</li>
                <li>introductions or referrals to claim processing partners, including Sentinel Legal Ltd;</li>
                <li>compliance monitoring and complaint handling.</li>
            </ul>
            <p>We do not sell your personal data.</p>

            <h3>3.4 Referral to Sentinel Legal Ltd</h3>
            <p>
                We will not pass your enquiry to Sentinel Legal Ltd merely because you visited this website or requested
                general information. We will only pass your personal data to Sentinel Legal Ltd where you have taken a
                clear step asking for your enquiry to be assessed or referred, or where the consent wording you accepted
                at the point your details were collected clearly stated that your information would be shared with
                Sentinel Legal Ltd for this purpose.
            </p>
            <p>Sentinel Legal Ltd is also known as Sentinel Legal.</p>
            <p>
                Sentinel Legal Ltd
                <br />
                SRA Number: 811792
                <br />
                Company Number: 12826774
                <br />
                Registered Office: Harley House, 29 Cambray Place, Cheltenham, GL50 1JN
                <br />
                Website: www.sentinellegal.co.uk
            </p>
            <p>
                Sentinel Legal Ltd is authorised and regulated by the Solicitors Regulation Authority and is authorised
                to provide legal services.
            </p>
            <p>The personal data shared with Sentinel Legal Ltd may include:</p>
            <ul>
                <li>your name;</li>
                <li>telephone number;</li>
                <li>email address;</li>
                <li>address or postcode;</li>
                <li>date of birth, where required;</li>
                <li>details of your motor finance enquiry;</li>
                <li>vehicle finance information, where provided;</li>
                <li>lender, broker, dealer or agreement information, where provided;</li>
                <li>records of your consent;</li>
                <li>details of your communication preferences;</li>
                <li>call notes or enquiry notes;</li>
                <li>
                    any information you provide about vulnerability, health, financial difficulty or personal
                    circumstances, where relevant and lawful;
                </li>
                <li>documents or evidence you upload or provide;</li>
                <li>signed authorities, forms or declarations, where applicable.</li>
            </ul>
            <p>We share this information so that Sentinel Legal Ltd can:</p>
            <ul>
                <li>assess whether you may have a potential motor finance claim;</li>
                <li>contact you about your enquiry;</li>
                <li>complete client onboarding;</li>
                <li>verify information relevant to your matter;</li>
                <li>carry out eligibility checks;</li>
                <li>advise you on next steps;</li>
                <li>manage your claim if you choose to proceed;</li>
                <li>comply with its own legal, professional and regulatory obligations.</li>
            </ul>
            <p>
                Sentinel Legal Ltd acts as an independent Data Controller once it receives your personal data. This
                means Sentinel Legal Ltd is responsible for how it uses, stores, retains and shares your personal data
                for legal services and related purposes.
            </p>
            <p>
                You should read Sentinel Legal Ltd&rsquo;s own privacy notice for further information about how it
                processes personal data.
            </p>

            <h3>3.5 Claim Submission and Processing by Sentinel Legal Ltd</h3>
            <p>
                Where you complete a motor finance claim webform that is operated by, hosted for, or transmitted
                directly to Sentinel Legal Ltd, your claim data may be submitted directly to Sentinel Legal Ltd.
            </p>
            <p>Sentinel Legal Ltd acts as the independent Data Controller for:</p>
            <ul>
                <li>claim form submissions;</li>
                <li>client onboarding;</li>
                <li>identity and eligibility checks;</li>
                <li>claim assessment;</li>
                <li>legal advice and claim management;</li>
                <li>communications relating to your claim;</li>
                <li>claim-related document storage;</li>
                <li>claim-related complaints;</li>
                <li>regulatory and professional compliance;</li>
                <li>file retention and deletion.</li>
            </ul>
            <p>
                Evans Hughes Ltd does not control how Sentinel Legal Ltd processes claim data once it has been submitted
                to Sentinel Legal Ltd.
            </p>
            <p>
                Where Evans Hughes Ltd does not receive or store the full claim form data, Evans Hughes Ltd will only
                process the limited information it receives for marketing, referral, compliance, audit, record keeping
                or complaint handling purposes.
            </p>

            <h2>4. Commercial Relationship and Referral Transparency</h2>
            <p>
                Evans Hughes Ltd may receive a commercial benefit, referral fee, marketing fee, administration fee or
                other payment where an enquiry is referred to Sentinel Legal Ltd or where a referred matter proceeds.
            </p>
            <p>
                Any such arrangement does not increase the amount you pay to Evans Hughes Ltd for making the enquiry.
            </p>
            <p>
                Sentinel Legal Ltd is responsible for providing any client care, costs, referral fee or legal services
                information that it is required to provide under the Solicitors Regulation Authority Standards and
                Regulations, SRA transparency requirements, or any other applicable professional rules.
            </p>
            <p>
                You are not obliged to proceed with Sentinel Legal Ltd. You may choose to contact your lender directly,
                complain directly to the Financial Ombudsman Service where eligible, or instruct another legal
                representative.
            </p>

            <h2>5. Personal Data Processed by Evans Hughes Ltd</h2>
            <p>Evans Hughes Ltd may process:</p>
            <ul>
                <li>your name;</li>
                <li>telephone number;</li>
                <li>email address;</li>
                <li>address or postcode;</li>
                <li>date of birth, where provided;</li>
                <li>basic enquiry information;</li>
                <li>campaign source information;</li>
                <li>consent records;</li>
                <li>marketing preferences;</li>
                <li>opt-out records;</li>
                <li>records of communications with us;</li>
                <li>call recordings;</li>
                <li>SMS and email history;</li>
                <li>technical website usage data;</li>
                <li>complaint information;</li>
                <li>compliance and audit records.</li>
            </ul>
            <p>We may also process limited information relating to your potential motor finance claim, such as:</p>
            <ul>
                <li>whether you have had vehicle finance;</li>
                <li>the approximate date of any finance agreement;</li>
                <li>lender, broker or dealer information;</li>
                <li>whether your agreement is current or settled;</li>
                <li>whether you wish to be referred for claim assessment.</li>
            </ul>
            <p>
                Where claim form data is submitted directly to Sentinel Legal Ltd, Evans Hughes Ltd does not control how
                that claim data is processed by Sentinel Legal Ltd.
            </p>

            <h2>6. Special Category Data and Vulnerability Information</h2>
            <p>
                In some cases, you may provide information about your health, disability, vulnerability, financial
                difficulty, personal circumstances or other sensitive matters.
            </p>
            <p>
                We will only process this type of information where necessary and lawful. Where required, we will ask
                for your explicit consent.
            </p>
            <p>
                We may share relevant vulnerability or special category information with Sentinel Legal Ltd where this
                is necessary so that Sentinel Legal Ltd can:
            </p>
            <ul>
                <li>assess your matter properly;</li>
                <li>provide appropriate support;</li>
                <li>make reasonable adjustments;</li>
                <li>understand any impact the matter may have had on you;</li>
                <li>comply with legal, regulatory or professional obligations.</li>
            </ul>
            <p>You should only provide sensitive information where it is relevant to your enquiry or claim.</p>
            <p>
                We will not use health, vulnerability, disability, financial difficulty or other special category
                information for marketing segmentation. Where such information is processed, it will be used only where
                necessary for support, reasonable adjustments, claim assessment, regulatory compliance, complaint
                handling or legal claims handling.
            </p>

            <h2>7. Lawful Basis for Processing</h2>
            <p>Evans Hughes Ltd processes personal data under the following lawful bases.</p>

            <h3>7.1 Consent</h3>
            <p>
                We rely on consent where you have agreed to us contacting you or processing your personal data for a
                specific purpose.
            </p>
            <p>This may include:</p>
            <ul>
                <li>telephone contact;</li>
                <li>SMS contact;</li>
                <li>email contact;</li>
                <li>WhatsApp contact;</li>
                <li>referral of your enquiry to Sentinel Legal Ltd;</li>
                <li>processing of special category data where explicit consent is required.</li>
            </ul>
            <p>
                Electronic marketing communications are conducted on the basis of consent where required by the Privacy
                and Electronic Communications Regulations.
            </p>
            <p>
                You can withdraw your consent at any time by contacting us or by using any opt-out method provided in
                our communications.
            </p>

            <h3>7.2 Legitimate Interests</h3>
            <p>
                We may rely on legitimate interests where processing is necessary for our business, provided your rights
                and freedoms do not override those interests.
            </p>
            <p>This may include:</p>
            <ul>
                <li>responding to enquiries;</li>
                <li>keeping accurate records;</li>
                <li>monitoring compliance;</li>
                <li>managing supplier and partner relationships;</li>
                <li>handling complaints;</li>
                <li>defending legal claims;</li>
                <li>preventing fraud or misuse;</li>
                <li>improving our services;</li>
                <li>carrying out internal administration.</li>
            </ul>
            <p>
                Where PECR requires consent for SMS, email, WhatsApp or other electronic marketing, we do not rely on
                legitimate interests as a substitute. In those cases, consent is the lawful basis for the relevant
                marketing processing.
            </p>

            <h3>7.3 Legal Obligation</h3>
            <p>
                We may process your personal data where necessary to comply with legal or regulatory obligations,
                including obligations imposed by:
            </p>
            <ul>
                <li>the Financial Conduct Authority;</li>
                <li>the Information Commissioner&rsquo;s Office;</li>
                <li>HMRC;</li>
                <li>courts or tribunals;</li>
                <li>law enforcement agencies;</li>
                <li>other competent regulatory bodies.</li>
            </ul>

            <h3>7.4 Establishment, Exercise or Defence of Legal Claims</h3>
            <p>
                Where necessary, we may process personal data to establish, exercise or defend legal claims, respond to
                complaints, manage disputes, or retain evidence of consent, instructions and communications.
            </p>

            <h2>8. Marketing Communications and PECR</h2>
            <p>
                If you have consented, Evans Hughes Ltd may contact you regarding your motor finance claim enquiry by
                telephone, SMS, email, WhatsApp or other communication methods.
            </p>
            <p>
                Where your data was collected by Offer Vault or another marketing partner, we rely on the consent
                information provided to us by that partner. This may include the date and time of consent, the wording
                shown to you, the method of collection, the campaign source and your contact preferences.
            </p>
            <p>
                For SMS, email, WhatsApp and other electronic marketing communications, we will only contact you where
                valid consent has been obtained and recorded, unless a lawful exemption clearly applies. Where your data
                was collected by a third-party marketing partner, we require evidence of the consent wording, source
                page, date, time, IP address, form version, communication preferences and opt-out status before using
                your details for electronic marketing.
            </p>
            <p>Our SMS messages and marketing communications will:</p>
            <ul>
                <li>identify the sender or brand;</li>
                <li>relate to the motor finance claim enquiry you submitted;</li>
                <li>provide a clear way to opt out;</li>
                <li>record and respect opt-out requests.</li>
            </ul>
            <p>You may withdraw consent or opt out at any time by:</p>
            <ul>
                <li>following the opt-out instructions in the message;</li>
                <li>replying STOP where available;</li>
                <li>emailing info@evanshughes.co.uk;</li>
                <li>
                    contacting Offer Vault at info@beclaimsready.co.uk if your query relates to the original consent
                    capture.
                </li>
            </ul>
            <p>
                If you opt out, unsubscribe, withdraw consent or object to direct marketing, we will stop marketing to
                you and may retain limited details on a suppression or do not contact list so that we do not contact you
                again by mistake.
            </p>

            <h2>9. Who We Share Your Personal Data With</h2>
            <p>Evans Hughes Ltd may share personal data with:</p>
            <ul>
                <li>
                    Sentinel Legal Ltd, where your enquiry is to be assessed or progressed as a potential motor finance
                    claim;
                </li>
                <li>
                    Be Claims Ready Ltd trading as Offer Vault, where required to verify consent, investigate complaints
                    or deal with data queries;
                </li>
                <li>
                    companies within Sentinel Legal&rsquo;s group, where relevant to claim assessment or legal services;
                </li>
                <li>
                    professional advisers we instruct or refer you to, including barristers, medical professionals,
                    accountants, tax advisers or other experts;
                </li>
                <li>third parties where necessary to carry out your instructions;</li>
                <li>
                    credit reference agencies or data providers, where required and where an appropriate lawful basis
                    applies;
                </li>
                <li>insurers and brokers;</li>
                <li>external auditors;</li>
                <li>banks and payment providers;</li>
                <li>
                    external service suppliers, representatives and agents that we use to make our business more
                    efficient, including IT providers, call handling providers, CRM providers, document storage
                    providers, marketing agencies, document collation providers or analysis suppliers;
                </li>
                <li>
                    regulatory authorities, law enforcement agencies, courts or public bodies where required;
                </li>
                <li>
                    potential buyers, investors or stakeholders in the event of a business sale, restructure or
                    transfer, subject to confidentiality protections where appropriate.
                </li>
            </ul>
            <p>
                We only allow service providers to handle personal data if we are satisfied that they take appropriate
                measures to protect it. We also impose contractual obligations on service providers to ensure they only
                use personal data for agreed purposes.
            </p>
            <p>We do not sell your personal data.</p>

            <h2>10. Credit Reference Agencies and Soft Searches</h2>
            <p>
                For some motor finance claim enquiries, you may be asked to consent to a soft credit search or data
                search to help identify potential motor finance agreements.
            </p>
            <p>
                A soft search is used to help locate relevant finance information and should not affect your credit
                score.
            </p>
            <p>
                Where such searches are used, you will be told what type of search is being carried out, who is carrying
                it out, and why it is needed.
            </p>
            <p>
                We will not carry out, or ask a third party to carry out, any credit reference agency search, soft
                search, Open Banking check or data search unless you have first been told who will carry out the search,
                what data will be used, why the search is needed, whether it leaves a footprint, whether it affects your
                credit score, and whether refusal affects your enquiry.
            </p>

            <h2>11. Call Recording and Monitoring</h2>
            <p>We may record calls and retain copies of communications for:</p>
            <ul>
                <li>compliance;</li>
                <li>quality assurance;</li>
                <li>staff training;</li>
                <li>complaint handling;</li>
                <li>regulatory monitoring;</li>
                <li>evidence of consent, instructions or authority;</li>
                <li>fraud prevention;</li>
                <li>defending legal claims.</li>
            </ul>
            <p>
                Call recordings and communication records are retained for a minimum of 12 months or longer where
                required for compliance, complaints, regulatory purposes or legal claims.
            </p>

            <h2>12. Data Retention</h2>
            <p>
                Evans Hughes Ltd retains personal data only for as long as necessary for the purposes for which it was
                collected.
            </p>
            <p>This may include retaining data to:</p>
            <ul>
                <li>manage enquiries;</li>
                <li>maintain records of consent;</li>
                <li>comply with FCA and legal obligations;</li>
                <li>handle complaints;</li>
                <li>defend potential legal claims;</li>
                <li>monitor marketing and partner compliance;</li>
                <li>evidence referral activity;</li>
                <li>comply with audit, accounting or regulatory requirements.</li>
            </ul>
            <p>
                We do not retain full claim data where that data is submitted directly to Sentinel Legal Ltd and is not
                received by Evans Hughes Ltd.
            </p>
            <p>
                Where Evans Hughes Ltd processes enquiry, marketing, consent or referral records, we may retain those
                records for up to six years from the end of the relationship or last meaningful contact, unless a longer
                period is required or justified by law, regulation, complaint handling, regulatory enquiry or legal
                claims.
            </p>

            <h2>13. Data Security</h2>
            <p>
                We implement appropriate technical and organisational measures to protect personal data, including:
            </p>
            <ul>
                <li>secure systems;</li>
                <li>access controls;</li>
                <li>password protection;</li>
                <li>restricted access permissions;</li>
                <li>supplier due diligence;</li>
                <li>secure data transfer methods;</li>
                <li>staff training;</li>
                <li>record keeping and audit procedures;</li>
                <li>data processing agreements where required.</li>
            </ul>
            <p>
                No system can be guaranteed to be completely secure. You should take care when sending information to us
                and avoid providing unnecessary sensitive information unless requested.
            </p>

            <h2>14. International Transfers</h2>
            <p>
                We will generally store your personal data in the United Kingdom or European Economic Area.
            </p>
            <p>
                Where personal data is transferred outside the UK or EEA, we will ensure appropriate safeguards are in
                place, such as adequacy regulations, standard contractual clauses, international data transfer
                agreements or other legally recognised safeguards.
            </p>

            <h2>15. Your Rights</h2>
            <p>Under UK GDPR, you have the right to:</p>
            <ul>
                <li>access your personal data;</li>
                <li>ask us to correct inaccurate or incomplete data;</li>
                <li>ask us to erase your data in certain circumstances;</li>
                <li>ask us to restrict processing in certain circumstances;</li>
                <li>object to processing in certain circumstances;</li>
                <li>request data portability in certain circumstances;</li>
                <li>withdraw consent where processing is based on consent;</li>
                <li>complain to the Information Commissioner&rsquo;s Office.</li>
            </ul>
            <p>
                To exercise your rights in relation to personal data processed by Evans Hughes Ltd, contact:
                info@evanshughes.co.uk
            </p>
            <p>Where your request relates to data collected by Offer Vault, you should contact: info@beclaimsready.co.uk</p>
            <p>
                Where your request relates to claim data or legal services data processed by Sentinel Legal Ltd, you
                should contact Sentinel Legal Ltd directly.
            </p>

            <h2>16. Data Complaints and Queries</h2>
            <p>Please contact the relevant organisation depending on your concern.</p>
            <h3>Data Collection or Consent Issues</h3>
            <p>
                Be Claims Ready Ltd trading as Offer Vault
                <br />
                Company Number: 11183295
                <br />
                Registered Office: 8 Cwrt Ty Mawr, Penarth, Vale Of Glamorgan, CF64 3PZ
                <br />
                Email: info@beclaimsready.co.uk
                <br />
                ICO Registration: ZB939102
            </p>
            <h3>Marketing Communications from Evans Hughes Ltd</h3>
            <p>
                Evans Hughes Ltd
                <br />
                Email: info@evanshughes.co.uk
                <br />
                ICO Registration: ZA754708
            </p>
            <h3>Claim Processing or Claim Data</h3>
            <p>
                Sentinel Legal Ltd
                <br />
                SRA Number: 811792
                <br />
                Company Number: 12826774
                <br />
                Registered Office: Harley House, 29 Cambray Place, Cheltenham, GL50 1JN
                <br />
                Website: www.sentinellegal.co.uk
            </p>
            <p>You may also lodge a complaint with the Information Commissioner&rsquo;s Office.</p>
            <p>
                ICO Website: www.ico.org.uk
                <br />
                ICO Telephone: 0303 123 1113
            </p>

            <h2>17. Third-Party Websites</h2>
            <p>
                Our website or communications may contain links to third-party websites, including websites operated by
                Sentinel Legal Ltd, Offer Vault, regulators or service providers.
            </p>
            <p>
                We are not responsible for the privacy practices or content of third-party websites. You should read
                their privacy policies before providing personal data to them.
            </p>

            <h2>18. Changes to This Policy</h2>
            <p>
                We may update this privacy policy from time to time to reflect changes in our business, regulatory
                requirements, legal obligations, marketing activity or data processing arrangements.
            </p>
            <p>The latest version will appear on this page.</p>
        </div>
    )
}

export default PrivacyPolicy
